import {useRouter} from 'next/router';
import {useCallback, useMemo} from 'react';
import {SetListDialog} from '../../../../design-system/organisms/SetListDialog/SetListDialog';
import {useDialog} from '../../../../dialog/useDialog.hook';
import {
  Maybe,
  NormalListViewItem as NormalListViewItemType,
} from '../../../../graphql/generated/types';

export function useContentHomeSetListDialog({
  isMobile,
  setList,
}: {
  isMobile: boolean;
  setList?: Maybe<Maybe<NormalListViewItemType>[]>;
}) {
  const router = useRouter();
  const {isOpen, showDialog, hideDialog} = useDialog({
    isMobile,
  });

  const onClickSet = useCallback(
    (setId: string) => {
      router.push(`/content/set-overview/${setId}`);
    },
    [router]
  );

  const dialogElem = useMemo(() => {
    if (!setList || !isOpen) {
      return null;
    }

    return (
      <SetListDialog
        setList={setList as NormalListViewItemType[]}
        onClickSet={onClickSet}
        onClickCancel={hideDialog}
        isMobile={isMobile}
      />
    );
  }, [setList, isOpen, onClickSet, hideDialog, isMobile]);

  return {
    showDialog,
    dialogElem,
  };
}
